<template>
  <div class="add">
    <form v-on:submit.prevent="addBookmark">
      <p>
        <label>Title</label><br />
        <input v-model="title" type="text" />
      </p>
      <p>
        <label>Url</label><br />
        <input v-model="url" type="text" />
      </p>
      <p>
        <label>tags</label><br />
        <input v-model="tags" type="text" ref="tags" />
      </p>
      <p>
        <button type="submit">add bookmark</button>
      </p>
    </form>
  </div>
</template>

<script>
export default {
  name: "Add",
  data: function() {
    return {
      title: "",
      url: "",
      tags: ""
    };
  },
  methods: {
    addBookmark: function() {
      fetch(this.$root.api, {
        method: "post",
        headers: {
          authorization:
            "Bearer " + JSON.parse(window.localStorage.getItem("id_token")).t,
          "content-type": "application/json"
        },
        body: JSON.stringify({
          title: this.title,
          url: this.url,
          tags: this.tags.split(" ")
        })
      }).then(() => window.close());
    }
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    this.title = params.get("title");
    this.url = params.get("url");
  },
  mounted() {
    this.$refs.tags.focus();
  }
};
</script>
